import { ThreadsPostItemModelV1 } from '@/types/threads';
import dayjs from 'dayjs';
import { useTranslation } from 'next-i18next';

interface ThreadsPostHeaderProps {
  mediaName?: string;
  post?: ThreadsPostItemModelV1;
}

const ThreadsPostHeader: React.FC<ThreadsPostHeaderProps> = ({ mediaName, post }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-8 max-md:mb-[18px]">
      {/* 发布时间 */}
      <div className="mb-3 text-[16px] leading-[22px] font-medium">
        @{mediaName} {t('Posted on')} {dayjs(post.publish_time).format('MM/DD/YY')}
      </div>

      {/* 帖子文本内容 */}
      {post.caption_text && (
        <div className="text-[16px] leading-[22px] text-[#0C0C0C99] max-md:text-[13px] max-md:leading-5">
          {post.caption_text}
        </div>
      )}
    </div>
  );
};

export default ThreadsPostHeader;
